module.exports = __webpack_public_path__ + "assets/financialinvestigator.b45caa96.svg";